'use client';

export { default } from './Switch';
export { default as switchClasses } from './switchClasses';
export * from './switchClasses';
export * from './SwitchProps';